import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../StateContext/Application'
import { apiurl } from '../../../../path'
import { useLanguage } from '../../../../lang/langcontext/LanguageContext'
const BudgetEstimationList = () => {
     const { language, toggleLanguage, t } = useLanguage();
    const context = useContext(AdminContext)
    const { GetAllBudgetEstimationList } = context
    const [budgetEstimation, setBudgetEstimationList] = useState([])
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

    const getBudgetEstimationList = async () => {
        let data = await GetAllBudgetEstimationList()
        console.log("data",data);
        
        setBudgetEstimationList(data)
        setFilteredBills(data);
    }
    useEffect(() => {
        getBudgetEstimationList()
    }, [])
    let budgetEstimationList = []
    if (budgetEstimation.length > 0) {
        budgetEstimationList = budgetEstimation
    }
    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = budgetEstimation.filter(bill =>
            Object.values(bill).some((val) =>
                (val || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1); // Reset to page 1 on search
    }, [searchTerm, budgetEstimation]);
    // return (
    //     <div style={{ overflowX: "hidden", display: 'grid', justifyContent: 'center', padding: "20px 0px" }}>
    //         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "80vw", maxWidth: "1200px", marginBottom: "15px" }}>
    //             <h4 style={{ margin: "10px" }}>Budget Estimation Report</h4>
    //             <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} />
    //         </div>
    //         <div style={{ display: "grid", justifyContent: "center", width: "80vw", maxWidth: "100%", }}>
    //             <div style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', display: 'flex', width: '75vw', overflowX: "auto", border: '1px solid #3b409e' }}>
    //                 <table style={{ width: '100%', width: "100%", borderCollapse: "collapse", minWidth: "1200px", }}>
    //                     <thead style={{ borderTop: 'none' }}>
    //                         <tr style={{ color: 'white', border: 'none', overflow: 'hidden', height: '3.5rem' }}>
    //                             <th style={{ padding: '8px' }}>Project ID</th>
    //                             <th style={{ padding: '8px' }}>Project Name</th>
    //                             <th style={{ padding: '8px' }}>Financial Year</th>
    //                             <th style={{ padding: '8px' }}>Budget ID</th>
    //                             <th style={{ padding: '8px' }}>Budget Head</th>
    //                             <th style={{ padding: '8px' }}>Esitmate Amount</th>
    //                             <th style={{ padding: '8px' }}>Date</th>
    //                         </tr>
    //                     </thead>
    //                     {
    //                         currentBills?.map((budgetEstimation, index) => {
    //                             const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
    //                             return (
    //                                 <tbody>
    //                                     <tr style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor, }}>
    //                                         <td style={{ padding: '8px' }}>{budgetEstimation.ProjectID}</td>
    //                                         <td style={{ padding: '8px' }}>{budgetEstimation.ProjectName}</td>
    //                                         <td style={{ padding: '8px' }}>{budgetEstimation.Year}</td>
    //                                         <td style={{ padding: '8px' }}>{budgetEstimation.BudgetID}</td>
    //                                         <td style={{ padding: '8px' }}>{budgetEstimation.BudgetHead}</td>
    //                                         <td style={{ padding: '8px' }}>{budgetEstimation.EsitmateAmount}</td>
    //                                         <td style={{ padding: '8px' }}>{budgetEstimation.Date?.split('T')[0].replace(' ')}</td>
    //                                     </tr>
    //                                 </tbody>
    //                             )
    //                         })
    //                     }
    //                 </table>
    //             </div>
    //         </div>
    //         <div style={{ display: 'flex', justifyContent: 'space-between', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
    //             <div>
    //                 <p style={{ margin: '0px', color: 'black' }}>Showing {filteredBills?.length} of {budgetEstimation?.length} entries</p>
    //             </div>
    //             <div style={{ display: 'flex', alignItems: 'center' }}>
    //                 {/* First Page Button */}
    //                 <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
    //                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
    //                     &laquo;
    //                 </button>
    //                 {/* Previous Button */}
    //                 <button
    //                     onClick={() => setCurrentPage(currentPage - 1)}
    //                     disabled={currentPage === 1}
    //                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
    //                     &lt;
    //                 </button>

    //                 <button
    //                     style={{background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
    //                 </button>
    //                 {/* Next Button */}
    //                 <button
    //                     onClick={() => setCurrentPage(currentPage + 1)}
    //                     disabled={currentPage === totalPages}
    //                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
    //                     &gt;
    //                 </button>
    //                 {/* Last Page Button */}
    //                 <button
    //                     onClick={() => setCurrentPage(totalPages)}
    //                     disabled={currentPage === totalPages}
    //                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
    //                     &raquo;
    //                 </button>
    //             </div>

    //         </div>
    //     </div>
    // )
       return (
        <div style={{ overflowX: "hidden", display: 'grid', justifyContent: 'center', padding: "20px 0px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "80vw", maxWidth: "1200px", marginBottom: "15px" }}>
                <h4 style={{ margin: "10px" }}>{t("Budget Estimation Report")}</h4>
                <input type="text" placeholder={t("Search")} onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} />
            </div>
            <div style={{ display: "grid", justifyContent: "center", width: "80vw", maxWidth: "100%", }}>
                <div style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', display: 'flex', width: '75vw', overflowX: "auto", border: '1px solid #3b409e' }}>
                    <table style={{ width: '100%', width: "100%", borderCollapse: "collapse", minWidth: "1200px", }}>
                        <thead style={{ borderTop: 'none' }}>
                            <tr style={{ color: 'white', border: 'none', overflow: 'hidden', height: '3.5rem' }}>
                                <th style={{ padding: '8px' }}>{t("Project ID")}</th>
                                <th style={{ padding: '8px' }}>{t("Project Name")}</th>
                                <th style={{ padding: '8px' }}>{t("Financial Year")}</th>
                                <th style={{ padding: '8px' }}>{t("Budget ID")}</th>
                                <th style={{ padding: '8px' }}>{t("Budget Head")}</th>
                                <th style={{ padding: '8px' }}>{t("Esitmate Amount")}</th>
                                <th style={{ padding: '8px' }}>{t("Date")}</th>
                            </tr>
                        </thead>
                        {
                            currentBills?.map((budgetEstimation, index) => {
                                const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                    <tbody>
                                        <tr style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor, }}>
                                            <td style={{ padding: '8px' }}>{budgetEstimation.ProjectID}</td>
                                            <td style={{ padding: '8px' }}>{budgetEstimation.ProjectName}</td>
                                            <td style={{ padding: '8px' }}>{budgetEstimation.Year}</td>
                                            <td style={{ padding: '8px' }}>{budgetEstimation.BudgetID}</td>
                                            <td style={{ padding: '8px' }}>{budgetEstimation.BudgetHead}</td>
                                            <td style={{ padding: '8px' }}>{budgetEstimation.EsitmateAmount}</td>
                                            <td style={{ padding: '8px' }}>{budgetEstimation.Date?.split('T')[0].replace(' ')}</td>
                                        </tr>
                                    </tbody>
                                )
                            })
                        }
                    </table>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
                <div>
                    <p style={{ margin: '0px', color: 'black' }}>{t("Showing")} {filteredBills?.length} {t("of")} {budgetEstimation?.length} {t("entries")}</p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* First Page Button */}
                    <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
                        &laquo;
                    </button>
                    {/* Previous Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &lt;
                    </button>

                    <button
                        style={{background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                    </button>
                    {/* Next Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &gt;
                    </button>
                    {/* Last Page Button */}
                    <button
                        onClick={() => setCurrentPage(totalPages)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &raquo;
                    </button>
                </div>

            </div>
        </div>
    )
}

export default BudgetEstimationList
